import { convertExcelToImpactAnswers } from '@/domain/impact-co2/utils/convert-excel-to-impact-answers/convert-excel-to-impact-answers';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { importImpactCo2Answers } from './import-impact-co2-answers.action';

type Params = {
  projectId: number;
  file: File;
  deleteExistingAnswers: boolean;
};

export const readAndImportTheGreenShotExcelFile = createAppAsyncThunk(
  'impactCo2/readAndImportTheGreenShotExcelFile',
  async (
    { projectId, file, deleteExistingAnswers }: Params,
    { extra: { snackbarGateway }, dispatch },
  ) => {
    try {
      const answers = await convertExcelToImpactAnswers(file);
      await dispatch(
        importImpactCo2Answers({ projectId, answers, deleteExistingAnswers }),
      );
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('ImportImpactCo2Answers.Message.error'));
}
